const CookiePolicyPopup = {
  HIDE_COOKIEPOLICY_POPUP: 'HIDE_COOKIEPOLICY_POPUP',
};

export default CookiePolicyPopup;